import { defineStore } from 'pinia'
import { alertBox } from '@/composables/silverBox';
import axios from 'axios';
import { convertToPersian, numberFormat, removeCommos } from '@/composables/digits';
export const useAuth = defineStore('authentication', {
    state: () => {
        return {
            token : '',
            profile : {},
            login : true,
            head : {
                avatar: { value: '...', icon: 'fa fa-unlock-alt', disabled: false },
                wallet: { value: '...', icon: 'fa fa-pencil-square-o', disabled: false },
                score: { value: '...', icon: 'fa fa-phone' }
            }
        }
    },
    actions: {
        getToken(){
            this.token = localStorage.getItem('token')
        },
        async getAuth(){
            this.getToken()
            if(this.token){
                const formData = new FormData()
                formData.append('token',this.token)
                axios.post(`https://radap.ir/Backend/api/section/follow/auth.php`,formData)
                .then( response => {
                    if(response.data.auth == true){
                        this.login = true
                        for(const key in response.data.data){
                            this.profile[key] = response.data.data[key]
                        }
                        this.setProfile(response.data.data)
                    }else{
                        this.login = false
                    }
                })
            }else{
                this.login = false
            }
        },
        setProfile(information) {
            this.head.avatar.value = information.name + ' ' + information.family;
            this.head.avatar.icon = 'fa fa-user';
            this.head.avatar.disabled = true;
        
            this.head.wallet.value = 0;
            for(let i in information['wallets']){
                if(information['wallets'][i].amount){
                        this.head.wallet.value += Number(removeCommos(information['wallets'][i].amount))
                }
            }
            this.head.wallet.icon = 'fa fa-credit-card';
            this.head.wallet.disabled = false;
        
            this.head.score.value = information.score + ' امتیاز';
            this.head.score.icon = 'fa fa-certificate';
        }
    }
})